import axios from 'axios';



//import config from '../../config.json';

const getAll = (url) => {
  var headers = {
    'Accept': 'application/json;odata=verbose',
    'Content-Type': 'application/json;odata=verbose'
  }
  return  axios.get(url,{headers});
};
const getAllpost = (url) => axios.post(url)

const getCtegories = async () => {
  const apiUrl="https://opendatadev2.tel-aviv.gov.il/_vti_bin/Opendata/openDataService.svc/GetListItems";//config.apiUrl;
  const categoriesList="OpenData_Categories";//config.lists.categories; 
  const { data: categoriesAll } = await getAll(`${apiUrl}?listName=${categoriesList}`);
  return categoriesAll;
};

export { getAll, getCtegories ,getAllpost};